import React from "react";
import { useParams } from "react-router-dom";
import { ProjectList } from "../helpers/ProjectList";
import GitHubIcon from "@mui/icons-material/GitHub";
import "../styles/ProjectDisplay.css";

function ProjectDisplay() {
  const { id } = useParams();
  const project = ProjectList[id];
  return (
    <div className="project">
      <h2> {project.name}</h2>
      <img src={project.image} alt='projects' />
      <p>
        <b>Skills:</b> {project.skills}
      </p>
      <a href={project.link} target="_blank" rel="noreferrer"><GitHubIcon /></a>
    </div>
  );
}

export default ProjectDisplay;